import React from 'react';
import { Card, Header, Segment } from "semantic-ui-react";

import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from 'react-image-gallery';

const ProjectGallery = (props) => (
        <Segment color='blue' raised={true}>
        <Header icon='photo' content='Project Gallery' size='small' />
        <Card centered fluid raised>
        <ImageGallery items={props.images} autoPlay={true} showFullscreenButton={false} slideInterval={6000} />
        <Card.Content>
            <Card.Description>
            ARGO Development Studio is an international, award-winning architectural practice specializing
            in a design and construction process called Building Information Modelling (BIM). BIM allows for
            buildings to be designed in a scientific way, making them increasingly resilient to the effects
            of natural disasters. This process allows ARGO to design, cost and construct intelligent
            buildings in a 3D virtual environment achieving savings of up to 20% over conventional 2D
            delivery.
            </Card.Description>
        </Card.Content>
        </Card>
    </Segment>
);

export default ProjectGallery;